export function getTheme() {
    return typeof window !== 'undefined' ? window.__theme : 'light';
}

export function setUserTheme(theme) {
    window.__setUserTheme(theme);
}
